"use client";

import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon, Minus } from "lucide-react";
import * as React from "react";

import { cn } from "@/utils";

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer border-gray-100 hover:border-blue-500 dark:bg-input/30 bg-white data-[state=checked]:bg-blue-500 data-[state=checked]:text-white dark:data-[state=checked]:bg-primary data-[state=checked]:border-blue-500 focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        "data-[state=indeterminate]:bg-white",
        "data-[state=indeterminate]:text-white",
        "data-[state=indeterminate]:text-white",
        "data-[state=indeterminate]:border-blue-500",
        "disabled:data-[state=checked]:bg-gray-100",
        "disabled:data-[state=checked]:border-gray-300",
        "disabled:data-[state=checked]:text-gray-300",

        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        {props.checked === "indeterminate" ? (
          <Minus className="size-3.5 !w-[12px] text-blue-600" strokeWidth={4} />
        ) : (
          <CheckIcon className="size-3.5" />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
